import React, { memo, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import StoreSellerProductsList from './StoreSellerProductsList';


const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});


const SellerStoreProductsHome = () => {
    const { lang } = useParams();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'HotDealsToday', language: "en-US" });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    return (
        <section className="sellerstore-products py-80">
            <div className="container container-md">
                <div className='row'>
                    <div className='col-12 col-lg-2'>
                        <div className='categorySide'>
                            <div className='side_menu_header d-flex align-items-center text-black gap-10'>
                                <i class="ph-bold ph-list-bullets"></i> <span>Category</span>
                            </div>
                            <ul className='side_nav ps-30 mt-10'>
                                <li>
                                    <a className='active' href='#'>All Products</a>
                                </li>
                                <li>
                                    <a href='#'>Category 1</a>
                                </li>
                                <li>
                                    <a href='#'>Category 2</a>
                                </li>
                                <li>
                                    <a href='#'>Category 3</a>
                                </li>
                                <li>
                                    <a href='#'>Category 4</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='col-12 col-lg-10'>
                        <div className="section-heading py-10 px-16">
                            <div className="d-flex justify-content-center justify-content-sm-between flex-wrap  flex-md-no-wrap gap-8 h-100">
                               <div className='sortHeader'>
                                    <div className='sortitems d-flex justify-content-between flex-wrap flex-sm-no-wrap align-items-center h-100 gap-8'>
                                        <span className='text-18 text-black text_quicksand fw-medium'>Sort by</span>
                                        <button className='btn_custom sort active'>Popular</button>
                                        <button className='btn_custom sort' >Newest</button>
                                        <button className='btn_custom sort' >Best Seller</button>
                                    </div>
                               </div>
                               <div className='paginationHeader'>
                                            <div className='d-flex align-items-center gap-10'>
                                                <span className='fw-medium text-18 text_quicksand text-black'>1/5</span>
                                                <div className='flex-center gap-10'>
                                                    <button className='pagination_btn page_prev flex-center rounded-circle'>
                                                        <i className="ph ph-caret-left" />
                                                    </button>
                                                    <button className='pagination_btn page_prev flex-center rounded-circle'>
                                                        <i className="ph ph-caret-right" />
                                                    </button>
                                                </div>
                                            </div>
                               </div>
                            </div>
                        </div>
                        <div className="row g-12">

                            <div className="col-md-12">
                                <StoreSellerProductsList />

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

    )
}

export default SellerStoreProductsHome